import getResponsiveWidth from '@wwdev/functions/getResponsiveWidth'
import addResizeFunction from "@wwdev/functions/addResizeFunction";
import formatPrice from "../functions/formatPrice";
import round from "../functions/round";
import FormConvertToObject from "../functions/FormConvertToObject";
import ProductAmountInput from '../components/product/amount-input';



class Configurator {
	constructor() {
		// return;
		this.makeSticky();
		addResizeFunction(this.makeSticky,200 )
		this.namespace = 'configurator';
		this.initEvents();

		console.log('INit configurator');
		this.requestData = {
			filter:{}
		};
		jQuery('#filters-wrapper input[type="radio"]:checked').trigger('change',false);
		// jQuery('#additional-options input[type="radio"]:checked').trigger('change',false);

	}
	initEvents() {
		jQuery('#filters-wrapper').on('change.'+ this.namespace, 'input[type="radio"]',this.handleChangeFilter.bind(this));
		jQuery('#additional-options').on('change.'+ this.namespace, 'input[type="radio"]',this.changeOption.bind(this));


		jQuery('.configurator-wrapper').on('show.bs.modal', this.initMaterials.bind(this) );
		jQuery('.configurator-wrapper').off(this.namespace);
		jQuery('.configurator-wrapper').on('change.'+ this.namespace, 'input[type="number"]',this.changeMaterialAmount.bind(this));
		jQuery('.configurator-wrapper').on('click.'+ this.namespace, 'button[save]',this.saveMaterialAmount.bind(this));


		jQuery('.configurator-wrapper').on('change', '.filter_group.feature-kleur-rail-deur-set- input', (event) =>{
			let selectedColor = jQuery(event.target).val();
			let sameColor = jQuery('.configurator-wrapper').find('.filter_group.feature-kleur-deurset input[value="'+selectedColor+ '"]');
			sameColor.trigger('click');
		});
	}

	async initMaterials() {
		console.log('show bs modal twee');
		this.update('get_materials');
	}



	handleChangeFilter(event, update = true) {
		let filterProps = jQuery(event.target).data();
		let filterPropId = filterProps.id;
		jQuery(event.target).parents('div.filter_group').find('input[type="radio"]').prop('checked', false);
		jQuery(event.target).prop('checked', true);
		this.requestData.filter[filterProps.treeId] = {}
		this.requestData.filter[filterProps.treeId][filterPropId] = filterProps.title;
		this.saveToLocalStorage();
		if (update) {
			clearTimeout(this.timer);
			this.timer = setTimeout( () =>
					this.update('save_filters')
				, 100);
		}
	}
	changeOption(event, update = true) {
		let optionData = jQuery(event.target).data();
		if (optionData.suboptiongroupId) {
			console.log(60);
			if (!this.requestData.hasOwnProperty('suboptions')) {
				this.requestData.suboptions = {};
			}
			if (!this.requestData.suboptions.hasOwnProperty(optionData.optiongroupId)) {
				this.requestData.suboptions[optionData.optiongroupId] = {};
			}
			this.requestData.suboptions[optionData.optiongroupId][optionData.suboptiongroupId] = optionData.optionId;
			if( optionData.optionId == "0" ) {
				jQuery(event.target).parents('.collapse:first').collapse('hide');
			} else {

				jQuery(event.target).parents('.collapseable:first').next().find('.collapse').collapse('show');
			}
		} else {
			console.log(75);
			if (!this.requestData.hasOwnProperty('options')) {
				this.requestData.options = {};
			}

			this.requestData.options[optionData.optiongroupId] = optionData.optionId;
			// jQuery(event.target).parents('div.options:first').find('.custom-options:visible').find(':input').prop('disabled', true);
			// jQuery(event.target).parents('div.options:first').find('.custom-options:visible').collapse('hide');
			//
			if( optionData.optionId == "0" ) {
				console.log(85, update);
				if (jQuery(event.target).parent().parent().find('.custom-options').length > 0) {
					// dit is een glazen schuifdeur
					this.requestData.suboptions = {};
					console.log(87, jQuery(event.target).parent().parent().find('.custom-options'));
					jQuery(event.target).parent().parent().find('.custom-options').addClass('d-none');
					jQuery(event.target).parent().parent().find('.custom-options').find(':input').prop('disabled', true);
					jQuery(event.target).parent().parent().find('.custom-options').find(':input:checked').prop('checked', false);
					// jQuery(event.target).parent().parent().find('.collapse').collapse('hide');
				} else {
					jQuery(event.target).parents('.collapse:first').collapse('hide');
				}

			} else {
				console.log(88, update);
				if (jQuery(event.target).parent().find('.custom-options').length > 0) {
					// dit is een glazen schuifdeur
					let customOptions = jQuery(event.target).parent().find('.custom-options');
					customOptions.removeClass('d-none');
					customOptions.find('.collapse:first').collapse('show')
					customOptions.find(':input').prop('disabled', false);
					customOptions.find('.collapseable:first').next().find('> .collapse').collapse('show');
				} else {
					if (jQuery(event.target).parent().parent().find('.custom-options').length > 0) {
						// dit is een glazen schuifdeur
						this.requestData.suboptions = {};
						console.log(87, jQuery(event.target).parent().parent().find('.custom-options'));
						jQuery(event.target).parent().parent().find('.custom-options').addClass('d-none');
						jQuery(event.target).parent().parent().find('.custom-options').find(':input').prop('disabled', true);
						jQuery(event.target).parent().parent().find('.custom-options').find(':input:checked').prop('checked', false);
						// jQuery(event.target).parent().parent().find('.collapse').collapse('hide');
					}
					if (update) {
						jQuery(event.target).parent().parent().find('.custom-options:visible').find(':input').prop('disabled', true);
						jQuery(event.target).parent().parent().find('.custom-options:visible').collapse('hide');
					}
					jQuery(event.target).parents('.collapseable:first').next().find('> .collapse').collapse('show');
				}

				// jQuery(event.target).parents('.collapseable:first').next().find('> .collapse').collapse('show');
			}
		}
		this.saveToLocalStorage();
		if (update) {
			clearTimeout(this.timer);
			this.timer = setTimeout( () =>
				this.update('save_options')
			, 100);
		}
	}
	makeSticky() {
		if (getResponsiveWidth() < 992) {
			jQuery(".sticky").trigger("sticky_kit:detach");
		} else {
			$('.sticky').stick_in_parent({offset_top: 90,inner_scrolling:true})
				.on('sticky_kit:detach');
		}
	}
	saveToLocalStorage() {
		return;
		localStorage.setItem('configurator.requestData', JSON.stringify(this.requestData));
	}

	update(action = 'update') {
		window.showLoader();
		this.toggleFilterOverlay();
		this.requestData.options = {};
		this.requestData.suboptions = {};
		let self = this;
		let checkedOptions = jQuery('#additional-options').find('input:checked');
		jQuery.each(checkedOptions, function(it, el) {
			if (el.value == 0) {
				return;
			}
			if(jQuery(el).data('suboptiongroupId')) {
				// self.requestData[]
				let groupId = jQuery(el).data('optiongroupId');
				let subgroupId = jQuery(el).data('suboptiongroupId');
				console.log(160, self.requestData.suboptions, typeof self.requestData.suboptions[groupId]);
				if (typeof self.requestData.suboptions[groupId] == 'undefined') {
					self.requestData.suboptions[groupId] = {};
				}
				self.requestData.suboptions[groupId][subgroupId] = el.value;
			} else {
				let groupId = jQuery(el).data('optiongroupId');
				self.requestData.options[groupId] = el.value;
			}

		});

		jQuery.postJSON('?action=' + action, this.requestData, this.drawResponse.bind(this));
	}

	toggleFilterOverlay() {
		jQuery('#filters div.loading-overlay').toggleClass('d-none');
	}

	drawResponse(response) {
		if (response.hasOwnProperty('filters')) {
			jQuery('#filters-wrapper').html(response.filters);
		}
		if (response.hasOwnProperty('options')) {
			jQuery('#additional-options').html(response.options);
		}
		if (response.hasOwnProperty('summary')) {
			jQuery('#summary').html(response["summary"]);
		}
		if (response.hasOwnProperty('materials')) {
			console.log('Marterials loadeed');
			jQuery('#materials .modal-body').html(response.materials);
		}
		new ProductAmountInput({
			scope: '#materials'
		});

		window.hideLoader();
		this.toggleFilterOverlay();
		//jQuery('#filters-wrapper').html(response.filters);
	}

	async saveMaterialAmount(event) {
		let $configurables = jQuery(event.delegateTarget).find('.configurable-product');
		let data = {
			action: 'save_materials',
			configurables: {}
		};

		$configurables.each(function(index, item){
			let $div = jQuery(item);
			data.configurables[$div.data('ident')] = FormConvertToObject( $div.find('input[type="number"]').serializeArray() );
		});
		let result = await jQuery.postJSON('', data, response => this.drawResponse(response) );
		$configurables.parents('.modal').modal('hide');
	}
	changeMaterialAmount(event) {
		let $wrapper = jQuery(event.target).parents('.configurable-product:first');
		let changedAmount = false;
		let ceChanged = false;
		let configuredPrice = 0

		$wrapper.find('tbody tr.material').each(function(index, item) {
			let $tr = jQuery(item);
			let materialData = $tr.data();

			let currentAmount = $tr.find('input[type="number"]:visible').val();
			if ( currentAmount < 1 ) {
				currentAmount = 0;
				$tr.find('input[type="number"]:visible').val(currentAmount);

			}
			if ( currentAmount != materialData.defaultAmount ) {
				changedAmount = true;
				if (materialData.ce) {
					ceChanged = true;
				}
				$tr.find('input[type="number"]:visible').parent().next().removeClass("d-none");
			} else {
				$tr.find('input[type="number"]:visible').parent().next().addClass("d-none");
			}

			let linePrice = round( currentAmount *  parseFloat(materialData.price) , 2) ;
			configuredPrice = round( configuredPrice + linePrice, 2) ;
			$tr.find('.subtotal').html('&euro; ' + formatPrice(linePrice ) );
		})
		$wrapper.find('.cekeurmerk').collapse( (ceChanged ? 'show' : 'hide' ) );

		let setPrice = parseFloat($wrapper.find('span[setprice]').data('price'));
		$wrapper.find('span[moreprice]').html(formatPrice(configuredPrice - setPrice ) )
		$wrapper.find('span[configuredprice]').html(formatPrice(configuredPrice) )
	}
}

export default new Configurator();